import Vue from 'vue'
import ut from '@/utils'

import {Resource} from 'vue-resource'

const Material = {
  id: null,
  name: '',
  buy_price: '',
  code: '',
  measurement: null,
  min_notified_amount: 0,
  is_active: true,
}

const MaterialResource = new Resource('/', {}, {
  list: {
    method: 'GET',
    url: 'warehouse/rawmaterial/list/',
  },
  details: {
    method: 'GET',
    url: 'warehouse/rawmaterial/detail/{id}/',
  },
  create: {
    method: 'POST',
    url: 'warehouse/rawmaterial/create/',
  },
  update: {
    method: 'PUT',
    url: 'warehouse/rawmaterial/update/{id}/',
  },
  remove: {
    method: 'DELETE',
    url: 'warehouse/rawmaterial/delete/{id}/',
  },
})

export default {
  namespaced: true,

  state: {
    data: null,

    fetching: false,
    model: ut.deepClone(Material),
    saving: false,
    deleting: {},
  },

  getters: {
    getMaterial: (state) => (id) => state.data?.results?.find(m => m.id === id),
  },

  mutations: {
    setItems(state, data) {
      state.data = data
    },

    setModel(state, data) {
      state.model = {...ut.deepClone(Material), ...data}
    },
  },

  actions: {
    fetch({state, commit}, filters = {}) {
      filters.limit = filters.limit || 1000

      if (!state.fetching) {
        commit('setItems', null)
        state.fetching = MaterialResource.list(ut.objFilter(filters))
          .then((response) => {
            commit('setItems', response.body)
          })
          .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    show({state, commit}, id) {
      if (!state.fetching) {
        commit('setModel', {})
        state.fetching = MaterialResource.details({id})
          .then(({body}) => {
            commit('setModel', body)
          })
          .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    save({state, commit}) {
      state.saving = true
      let promise
      if (state.model.id) {
        promise = MaterialResource.update({id: state.model.id}, state.model)
      } else {
        promise = MaterialResource.create(state.model)
      }

      return promise
        .then(({body}) => {
          commit('setModel', body)
        })
        .finally(() => state.saving = false)
    },

    remove({state, dispatch}, id) {
      Vue.set(state.deleting, id, true)
      return MaterialResource.remove({id})
        .then(() => dispatch('fetch'))
        .finally(() => Vue.set(state.deleting, id, false))
    },
  },
}
